import { AccountInfo } from '@azure/msal-browser'
import { action, makeObservable, observable } from 'mobx'
import { persist } from 'mobx-persist'
import type { User } from './types'

// const mockPermissions = [
//   'manage_chain',
//   'manage_users',
//   'manage_stations',
//   'manage_ownStation',
//   'manage_menus',
//   'manage_vitrineProducts',
//   'manage_checklists',
//   'edit_dailyManagement',
//   'edit_tasklist',
//   'edit_checklists',
//   'edit_weeklyInfo',
//   'edit_dailyInfo',
//   'edit_customerTargets',
//   'edit_preparationPlan',
//   'edit_cookingPlan',
//   'edit_vitrineProducts',
//   'nav_infos',
//   'nav_cooking',
//   'nav_admin',
//   'nav_basic',
//   'view_dashboard',
// ]

class AuthStore {
  @persist('object')
  @observable
  accessToken: string | null = null

  @observable
  @persist('object')
  user: User | null = null

  @persist('object')
  @observable
  account: AccountInfo | null = null

  constructor() {
    makeObservable(this)
  }

  getAccessToken() {
    return this.accessToken
  }

  @action
  setAccessToken(accessToken: string): void {
    this.accessToken = accessToken
  }

  @action
  setUser(user: User): void {
    this.user = user
  }

  @action
  logout(): void {
    this.accessToken = null
    this.user = null
    this.account = null
  }

  @action
  setAccount(account: AccountInfo | null): void {
    this.account = account
  }

  getUserPemissions(): Array<string> {
    return this.user ? this.user.permissions : []
  }

  userHasPermission(permissionName: string) {
    return this.getUserPemissions().indexOf(permissionName) !== -1
  }

  getUser() {
    return this.user
  }

  getUserFullName(): string {
    return this.user ? this.user.name : ''
  }

  getUserId(): string {
    return this.user ? this.user.id : ''
  }

  getAccount(): AccountInfo | null {
    return this.account
  }

  isUserLoggedIn(): boolean {
    return Boolean(this.user)
  }
}

export default new AuthStore()
